import { createActionGroup, props } from '@ngrx/store';
import { type SiteEntity } from '@common/types/site.type';
import { type SitePageEntity } from '@common/types/site-page.type';
import { type Id, type Uuid } from '@common/types';
import { type DenormalizedBlockEntity } from '@web/types';

type NavigateTo = { pageId?: string; siteId?: string; isNew?: boolean };
type SaveModalProps = { exit: boolean; publish: boolean; navigateTo?: NavigateTo };

const ModalsActions = createActionGroup({
    source: 'Modals',
    events: {
        'Show save confirm modal': props<SaveModalProps>(),
        'Show save modal handler': props<SaveModalProps>(),
        'Show save site modal': props<SaveModalProps>(),
        'Show save page modal': props<SaveModalProps>(),
        'Show copy page modal': props<{ siteId: number; page: SitePageEntity }>(),
        'Show copy block to page modal': props<{
            block: DenormalizedBlockEntity;
            currentSiteId: SiteEntity['id'];
            currentPageId: Id | Uuid;
        }>(),
        'Show confirm delete user library block modal': props<{ blockId: Uuid }>(),
    },
});

export default ModalsActions;
